import React, { useState, useEffect, useMemo } from "react";
import Switch from "@mui/material/Switch";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchManagerComponent from "../components/SearchManager/SearchManagerComponent";
import BannerCard from "../components/BannerCard";
import TemplateForms from "../components/TemplateForms";
import CustomModal from "../components/CustomModal";
import template_nodata from "../images/No_Template_Found_Icon.svg";
import toggleInactive from "../images/toggle-inactive.svg";
import toggleActive from "../images/toggle-active.svg";
import "../css/TemplateManger.scss";
import "react-toastify/dist/ReactToastify.css";
import CloneTemplate from "../components/template/CloneTemplate";
import ExportTemplate from "../components/ExportTemplate";
import { template } from "../utils/constants";
import "../css/editor.scss";
import SharedResource from "../components/SharedResource/SharedResource";
import GileadModal from "../components/GileadModal";
import WebActionVeeva from "../components/WebActionPage/WebActionVeeva";
import { getMarketDetails, getBrandDetails, getIndicationDetails, getMlrStatusList } from "../services/apis";

const Template = ({
  cardData,
  openCreateNewPresenationModal,
  handleDeletetemplate,
  createNewEdetail,
  openCreateNewtemplate,
  setOpenCreateNewtemplate,
  isloading,
  type,
  setIsloading,
  createEdetail,
  createTemplate,
  createPresentationFields,
  setCreatePresentationFields,
  edetailList,
  setEDetailFields,
  eDetailFields,
  sendSearchDataToEdetails,

  searchClicktemplate,

  openCloneTemplate,
  setOpenCloneTemplate,
  openCloneTemplateModal,
  closeCloneTemplateModal,
  cloneTempdata,
  setCloneTempdata,
  getEdetailList,
  brands,
  market,
  campaign,
  setShowHeading,
  showHeading,
  showTemplateRes,
  searchresults,
  handleExportModal,
  clicKRsdPreview,
  closeExportModal,
  openExportModal,
  textFieldValidationError,
  handleExport,
  totalCount,
  exportFormats,
  setExportFormats,
  marketDataList,
  devices,
  setDevices,
  dimensions,
  setshowFetchedResults,
  showFetchedResults,
  fetchMore,
  skipRange,
  hasMore,
  showCount,
  setCreatedbyMe,
  lastSearch,
  setLastSearch,
  lockTemplate,
  createdbyMe,
  infinteScrollRef,
  setSearchClickEdetail,
  cardDetailsHandler,
  expired,
  setExpired,
  expireTemplateHandler,
  sharedToggle,
  setSharedToggle,
  isOpenSharedModal,
  setIsOpenSharedModal,
  // openShardedHandler,
  appData,
  setLocalShared,
  localShared,
  setDeckIdCurrent,
  searchClickEdetail,
  cameFrom,
  fetchingList,
  fetchingListError,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [countriesList, setCountriesList] = useState();
  const [brandsList, setBrandsList] = useState();
  const [mlrStatusList, setMLRStatusList] = useState([]);
  const [indicationList, setIndicationList] = useState([]);
  
    const fetchMarket = () => {
        getMarketDetails((response, err, errCode) => {
          if (err) {
          } else {
            //parse and save
            // const data = response.data;
            if (response) {
              setCountriesList(response.data);
            }
          }
        });
  };
  const fetchBrands = () => {
        getBrandDetails((response, err, errCode) => {
          if (err) {
          } else {
            //parse and save
            // const data = response.data;
            if (response) {
              setBrandsList(response.data);
            }
          }
        });
    };

    const fetchMLRStatus = () => {
         getMlrStatusList((response, err, errCode) => {
            if (err) {
            } else {
              if (response) {
                setMLRStatusList(response.data);
              }
            }
          });
      }
    
      const fetchIndication = () => {
         getIndicationDetails((response, err, errCode) => {
            if (err) {
            } else {
              //parse and save
              // const data = response.data;
              if (response) {
                setIndicationList(response.data);
              }
            }
          });
      }
    
    useEffect(() => {
      fetchMarket();
      fetchBrands();
      fetchMLRStatus();
      fetchIndication();
    },[])
  const renderSearchResults = useMemo(() => {
    return (
      <div  className="searchResultBlock customScrollBar">
        {countriesList && showFetchedResults?.length > 0 ? (
          <InfiniteScroll
            dataLength={showFetchedResults.length}
            next={() => fetchMore(createdbyMe, skipRange, true, expired)}
            hasMore={hasMore}
            scrollableTarget="scrollableDiv"
            ref={infinteScrollRef}
          >
            <div className={`dashboard-card-parent-div ${searchClickEdetail ? 'filtersAppliedHeight':'withoutFilterAppliedHeight'}`} id="scrollableDiv">
            <div className="dashboard-card-child-div">
              {showFetchedResults.map((item, index) => {
                const imageKey = Date.now(); //Math.floor(Math.random() * 10);
                return (
                  <div className="col-md-2 bannerCard" key={index}>
                    <BannerCard
                      cardData={item}
                      type={item.type}
                      openCloneTemplate={openCloneTemplate}
                      setOpenCloneTemplate={setOpenCloneTemplate}
                      openCloneTemplateModal={openCloneTemplateModal}
                      closeCloneTemplateModal={closeCloneTemplateModal}
                      handleDeletetemplate={handleDeletetemplate}
                      clicKRsdPreview={clicKRsdPreview}
                      handleExportModal={handleExportModal}
                      closeExportModal={closeExportModal}
                      openExportModal={openExportModal}
                      handleExport={handleExport}
                      showFetchedResults={showFetchedResults}
                      lockTemplate={lockTemplate}
                      createdbyMe={createdbyMe}
                      cardDetailsHandler={cardDetailsHandler}
                      imageKey={imageKey}
                      expireTemplateHandler={expireTemplateHandler}
                      brands={brandsList}
                      countriesList={countriesList}
                      // setshowFetchedResults={setshowFetchedResults}
                      setshowFetchedResults={setshowFetchedResults}
                    />
                  </div>
                );
              })}
              </div>
              </div>
          </InfiniteScroll>
        ) : (<>
            {fetchingList ? 
            <div className="result-not-found">
              <div className="d-flex justify-content-center align-items-center" style={{position: "absolute", top: "0"}}>
              <div className="result-not-found-text">                
                <h2 className="result-not-found-messages">Loading...</h2>
                <h3 className="result-not-found-parameters"></h3>
              </div>
              </div>
            </div>
            :
          <div className="result-not-found">
            <div className="d-flex justify-content-center align-items-center" style={{position: "absolute", top: "0"}}>
            <img
              className="result-not-found-icon"
              src={template_nodata}
              width={600}
              height={321}
              alt=""
            />
            <div className="result-not-found-text">
              <h2 className="result-not-found-messages">{fetchingListError?"Unable to load right now. Please try again.":(searchClickEdetail?'NO Template FOUND':'Create your First Template')}</h2>
              <h3 className="result-not-found-parameters">{fetchingListError?'':(searchClickEdetail?'Please try searching with other search parameters':'')}</h3>
            </div>
            </div>
          </div>}
          </>
        )}
      </div>
    );
  }, [showFetchedResults, countriesList, brandsList, fetchingList, fetchingListError]);

  const switchToCreatedBy = (flag) => {
    infinteScrollRef?.current?.el?.scrollTo(0, 0);
    setCreatedbyMe(flag)
    fetchMore(flag, 0, false, expired);
   /*  infinteScrollRef?.current?.el?.scrollTo(0, 0);
    if (flag === "Me") {
      fetchMore(true, 0, false, expired);
    } else {
      fetchMore(false, 0, false, expired);
    } */
  };

  const handleChange = (event) => {
    infinteScrollRef?.current?.el?.scrollTo(0, 0);
    //setExpired(event.target.checked);
    setExpired(!expired);
    fetchMore(createdbyMe, 0, false, !expired); //!expired ? createdbyMe : true
  };
  useEffect(() => {
     /*  if(cameFrom=='/webaction')
      setShowModal(true) */
    },[])

  // const openShardedHandler = () => {
  //   console.log('gu');
  //   setOpenCreateNewtemplate(false);
  //   setIsOpenSharedModal(true);
  // }

  return (
    <>
      <div className=""> {/* templatePageContainer */}
       {/*  <div className="createNewEdetailbtnBlock">
          <div className="eDetail-Label">Template Manager</div>
          <div className="createEdetailbtnBlock">
            <button
              type="button"
              className="btn btn-primary"
              onClick={openCreateNewPresenationModal}
            >
              CREATE NEW TEMPLATE
            </button>
          </div>
        </div> */}
        {/* <SearchManager
          marketDataList={marketDataList}
          setEDetailFields={setEDetailFields}
          eDetailFields={eDetailFields}
          sendSearchDataToEdetails={sendSearchDataToEdetails}
          type={type}
          getEdetailList={getEdetailList}
          showHeading={showHeading}
          setShowHeading={setShowHeading}
          brands={brands}
          market={market}
          campaign={campaign}
          createdbyMe={createdbyMe}
          setCreatedbyMe={setCreatedbyMe}
          lastSearch={lastSearch}
          setLastSearch={setLastSearch}
          infinteScrollRef={infinteScrollRef}
          setSearchClickEdetail={setSearchClickEdetail}
          expired={expired}
          setExpired={setExpired}
        /> */}
        <div className="search-manager-container-board">
          <SearchManagerComponent  
            marketDataList={marketDataList}
              brands={brands}  
              market={countriesList}
              showCount={showCount}
              createPresentationFields={createPresentationFields}
              setCreatePresentationFields={setCreatePresentationFields}
            type={type}
            sendSearchDataToEdetails={sendSearchDataToEdetails}
            switchToCreatedBy={switchToCreatedBy}
            createdbyMe={createdbyMe}
            openCreateNewPresenationModal={openCreateNewPresenationModal}
            searchClickEdetail={searchClickEdetail}
            brandsList={brandsList}
            setBrandsList={setBrandsList}
            countriesList={countriesList} 
            setCountriesList={setCountriesList}
            mlrStatusList={mlrStatusList}
            setMLRStatusList={setMLRStatusList}
            indicationList={indicationList}
            >
          </SearchManagerComponent>
          </div>
        {/* <div className="row mt-3 template-card">
          <div className="col-md-6 tabSeparation">
            <div className=" searchResult">
              <div
                className={`createdByMe createdBy ${
                  createdbyMe ? "createdByActive" : ""
                }`}
                onClick={() => switchToCreatedBy("Me")}
              >{`Created by Me ${
                createdbyMe && showCount !== " "
                  ? showCount < 10 && showCount > 0
                    ? `(0${showCount})`
                    : `(${showCount})`
                  : ""
              }
           `}</div>
              <div
                className={`createdByOthers createdBy ${
                  !createdbyMe && showCount !== " " ? "createdByActive" : ""
                }`}
                onClick={() => switchToCreatedBy("Others")}
              >{`Created by Others ${
                !createdbyMe && showCount !== " "
                  ? showCount < 10 && showCount > 0
                    ? `(0${showCount})`
                    : `(${showCount})`
                  : ""
              }`}</div>
            </div>
          </div>
          <div className={`col-md-6 g-0 expireToggleSection `}>
            {" "}
            Show Expired Template{" "}
            <img
              src={expired ? toggleActive : toggleInactive}
              className="expireToggleActive"
              onClick={handleChange}
            />{" "}
          </div>
        </div> */}

        {/* Search results starts Loop*/}
        {renderSearchResults}
        {/* <div id="scrollableDiv" className="searchResultBlock customScrollBar">
          {showFetchedResults.length > 0 ? (
            <InfiniteScroll
              dataLength={showFetchedResults.length}
              next={() => fetchMore(createdbyMe, skipRange, true, expired)}
              hasMore={hasMore}
              scrollableTarget="scrollableDiv"
              ref={infinteScrollRef}
            >
              <div className="row">
                {showFetchedResults.map((item, index) => {
                  const imageKey = Date.now();//Math.floor(Math.random() * 10);
                  return (
                    <div className="col-md-3" key={index}>
                      <BannerCard
                        cardData={item}
                        type={item.type}
                        openCloneTemplate={openCloneTemplate}
                        setOpenCloneTemplate={setOpenCloneTemplate}
                        openCloneTemplateModal={openCloneTemplateModal}
                        closeCloneTemplateModal={closeCloneTemplateModal}
                        handleDeletetemplate={handleDeletetemplate}
                        handleExportModal={handleExportModal}
                        closeExportModal={closeExportModal}
                        openExportModal={openExportModal}
                        handleExport={handleExport}
                        showFetchedResults={showFetchedResults}
                        lockTemplate={lockTemplate}
                        createdbyMe={createdbyMe}
                        cardDetailsHandler={cardDetailsHandler}
                        imageKey={imageKey}
                        expireTemplateHandler={expireTemplateHandler}

                      // setshowFetchedResults={setshowFetchedResults}
                      />
                    </div>
                  );
                })}
              </div>
            </InfiniteScroll>
          ) : (
            <img
              className="template_nodata"
              src={template_nodata}
              width={400}
              height={250}
              alt=""
            />
          )}
        </div> */}
        {/* Search results Ends */}
      </div>
      {/* Search results Ends */}
       
      {/*  */} 
      
      {openCreateNewtemplate ? (
        <GileadModal
          openCreateNewtemplate={openCreateNewtemplate}
          setOpenCreateNewtemplate={setOpenCreateNewtemplate}
          type={type}
        ></GileadModal>
        
         /* <TemplateForms
          createPresentationFields={createPresentationFields}
          setCreatePresentationFields={setCreatePresentationFields}
          createNewEdetail={createNewEdetail}
          openCreateNewtemplate={openCreateNewtemplate}
          setOpenCreateNewtemplate={setOpenCreateNewtemplate}
          isloading={isloading}
          type={template}
          setIsloading={setIsloading}
          createEdetail={createEdetail}
          createTemplate={createTemplate}
          textFieldValidationError={textFieldValidationError}
          campaign={campaign ? campaign : null}
          brands={brands}
          market={market}
          sharedToggle={sharedToggle}
          setSharedToggle={setSharedToggle}
          isOpenSharedModal={isOpenSharedModal}
          setLocalShared={setLocalShared}
          localShared={localShared}
          // openShardedHandler={openShardedHandler}
        /> */
      ) : (
        ""
      )}
      {/* {sharedToggle && <SharedResource isOpenSharedModal={isOpenSharedModal}
      //setOpenSharedResource={setIsOpenSharedModal}
      deckIdCurrent={appData}
  
      />} */}
      {cameFrom == "webaction" ?<WebActionVeeva
        showModal={showModal}
        setShowModal={setShowModal}
       /*  setLocalShared={setLocalShared}
        localShared={localShared} */
        marketLi={market}
        brands={brands}
        marketDataList={marketDataList}
        type={template}
      /> : ''}

      {openCloneTemplate && (
        <CloneTemplate
          openCloneTemplate={openCloneTemplate}
          setOpenCloneTemplate={setOpenCloneTemplate}
          openCloneTemplateModal={openCloneTemplateModal}
          closeCloneTemplateModal={closeCloneTemplateModal}
          // showTemplateRes={showTemplateRes}
          cloneTempdata={cloneTempdata}
          setCloneTempdata={setCloneTempdata}
          getEdetailList={getEdetailList}
          brands={brands}
          market={market}
          campaign={campaign}
          createEdetail={createEdetail}
          sharedToggle={sharedToggle}
          setSharedToggle={setSharedToggle}
          setIsOpenSharedModal={setIsOpenSharedModal}
          setDeckIdCurrent={setDeckIdCurrent}
           marketDataListFetch={marketDataList}
        />
      )}
      {openExportModal && (
        <ExportTemplate
          closeExportModal={closeExportModal}
          openExportModal={openExportModal}
          // cardData={showTemplateRes}
          handleExport={handleExport}
          exportFormats={exportFormats}
          setExportFormats={setExportFormats}
        />
      )}
    </>
  );
};

export default Template;
